<template>
    <a-result status="404" title="404" sub-title="哎呀，页面怎么找不到呢" style="padding: 106px 32px;">
        <template #extra>
            <a-button type="primary" @click="getInfo()">
                返回首页
            </a-button>
        </template>
    </a-result>
</template>

<script>
export default {
    name: "notFind",
    methods: {
        getInfo() {
            this.$router.push({path: '/'})
        },
    },
}
</script>

<style scoped>

</style>
